/**
 * カスタムフォント（Phase 29.4）
 *
 * - 管理画面で .ttf / .otf / .woff / .woff2 をアップロード
 * - Storage パス: marketing/fonts/{filename}
 * - Firestore: customFonts/{id}
 * - admin-web 起動時に一覧を取得し、@font-face を動的注入
 * - 広告画像エディタのフォント選択肢に追加
 */
import type { IsoOrTimestamp } from './common';

export type CustomFontFormat = 'truetype' | 'opentype' | 'woff' | 'woff2';

export interface CustomFont {
  id: string;
  /** UI 表示用ラベル（例: "源ノ角ゴ Variable"） */
  name: string;
  /** CSS font-family 値（例: "MyBrandFont"） — エディタ・export 時にこの値で参照する */
  family: string;
  /** Storage の公開 URL */
  url: string;
  /** Storage パス（削除用） */
  storagePath: string;
  /** ファイル形式（@font-face format() ヒント用） */
  format: CustomFontFormat;
  /** バイトサイズ */
  size: number;
  createdAt: IsoOrTimestamp;
  createdBy?: string;
}

export const CUSTOM_FONT_STORAGE_PATH = 'marketing/fonts';
export const CUSTOM_FONT_MAX_BYTES = 5 * 1024 * 1024; // 5 MB

export function inferCustomFontFormat(filename: string): CustomFontFormat | null {
  const ext = filename.toLowerCase().split('.').pop();
  if (ext === 'ttf') return 'truetype';
  if (ext === 'otf') return 'opentype';
  if (ext === 'woff') return 'woff';
  if (ext === 'woff2') return 'woff2';
  return null;
}
